import { render, staticRenderFns } from "./FooterBanner.vue?vue&type=template&id=75d054b8&scoped=true&"
import script from "./FooterBanner.vue?vue&type=script&lang=js&"
export * from "./FooterBanner.vue?vue&type=script&lang=js&"
import style0 from "./FooterBanner.vue?vue&type=style&index=0&id=75d054b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d054b8",
  null
  
)

export default component.exports